import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _flatten from 'lodash/flatten';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import { FORM_FIELD_TYPES_VALIDATION_MAP } from './DynamicFormField.constants';
export function getFieldValidationFunction(field, value) {
  var widgetType = field.widgetType;
  var typeToFunction = FORM_FIELD_TYPES_VALIDATION_MAP[widgetType];
  if (_isFunction(typeToFunction)) {
    return typeToFunction(field, value);
  }
  return null;
}
export function validateFormFields(fields, fieldValues) {
  var flattenedFields = _flatten(fields);
  return flattenedFields.map(function (field) {
    var name = field.name;
    var error = getFieldValidationFunction(field, fieldValues[name]);
    return _isEmpty(error) ? null : _defineProperty({}, name, error[name]);
  }).filter(function (error) {
    return error !== null;
  }).reduce(function (acc, error) {
    return _objectSpread(_objectSpread({}, acc), error);
  }, {});
}